import React, { useState } from 'react';

import Card from '../../components/card/card';
import Sidebar from '../../components/sidebar/sidebar.component';
import styles from './resources-page.module.css';

export interface SidebarProps {
  currPage: string;
  setCurrPage: React.Dispatch<React.SetStateAction<string>>;
  isOpen: boolean;
  toggleSidebar: () => void;
}

export default function Resources() {
  const [currPage, setCurrPage] = useState<string>('resources');
  const [openSidebar, setOpenSidebar] = useState<boolean>(true);

  // Function to toggle the sidebar
  const toggleSidebar = () => setOpenSidebar(!openSidebar);

  const sidebarProps: SidebarProps = {
    currPage,
    setCurrPage,
    isOpen: openSidebar,
    toggleSidebar,
  };

  return (
    <div className="main">
      <Sidebar {...sidebarProps} />
      <Card
        cardClassName={styles.cardFormat}
        title={'Sarah Johnson' + ', Hiring Manager'}
        subtitle={'Company Name - San Jose, CA'}>
        <h4>email@gmail.com</h4>
      </Card>
    </div>
  );
}
